module.exports = __webpack_public_path__ + "static/media/Slide-02.b5f4e3ac.jpg";